<template>
    <div>
        <el-table :data="invoiceItems" style="width: 100%; border-top: 1px solid #eee;" size="small" empty-text="無資料">
            <el-table-column type="index" label="#" width="50"> </el-table-column>
            <el-table-column prop="iteM_NAM" label="品名">
                <template slot-scope="scope">
                    <div class="item-nam" :class="{'error': itemNamTxtLimit > 0 && scope.row.iteM_NAM.length > itemNamTxtLimit}">
                        {{ scope.row.iteM_NAM }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="pri" label="單價" align="right">
                <template slot-scope="scope">
                    <Money :v="scope.row.pri" />
                </template>
            </el-table-column>
            <el-table-column prop="qty" label="數量" align="right" width="50"> </el-table-column>
            <el-table-column prop="amt" label="金額（未稅）" align="right" width="110">
                <template slot-scope="scope">
                    <Money :v="scope.row.amt" />
                </template>
            </el-table-column>
        </el-table>
        <el-alert v-if="isShowTextLimitWarning" type="error" :closable="false">電子發票平台規定品名限制 {{ itemNamTxtLimit }} 字以內</el-alert>
    </div>
</template>

<script>
import { number } from 'echarts/core';

export default {
    props: {
        invoiceItems: {
            type: Array,
            default: () => [],
        },
        form: {
            type: Object,
            default: () => {},
        },
        itemNamTxtLimit: {
            type: Number,
            default: 0,
        },
    },
    components: {},
    data() {
        return {
            expend: true,
        };
    },
    computed: {
        isShowTextLimitWarning() {
            if (this.itemNamTxtLimit === 0)
                return false;

            for (let i = 0; i < this.invoiceItems.length; i++) {
                if (this.invoiceItems[i].iteM_NAM.length > this.itemNamTxtLimit)
                    return true;
            }
            return false;
        }
    }
};
</script>
<style lang="scss" scoped>
.item-nam {
    &.error {
        color: red;
    }
}
</style>
